import { ICountry } from 'models';
import { useEffect, useState } from 'react';
import { Api } from 'services/api';
import { GetAll } from 'services/country.service';
import { BaseGetAllParams } from 'services/defaults';

function mapCountry(item: ICountry) {
  return {
    ...item,
  };
}

export function useCountries(props: BaseGetAllParams = {}) {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>();
  const [data, setData] = useState<ICountry[]>();
  const [total, setTotal] = useState<number>();
  const [pagination, setPagination] = useState({ pageSize: 100, pageNumber: 1 });

  const load = async () => {
    const filters = {
      pageNumber: props.pageNumber ?? pagination.pageNumber,
      pageSize: props.pageSize ?? pagination.pageSize,
    };

    setLoading(true);
    await Api.tryCatch(
      GetAll(filters, { cancelToken: cancelToken.token }),
      (rs) => {
        setLoading(false);
        setData(rs.data.map(mapCountry));
        setTotal(rs.meta.total);
      },
      (err) => {
        setLoading(false);
        setError(err.message);
      },
    );
  };

  let cancelToken = Api.getCancelTokenSource();
  useEffect(() => {
    cancelToken = Api.getCancelTokenSource();
    return () => {
      cancelToken.cancel();
    };
  }, []);

  useEffect(() => {
    load();
  }, [props.pageNumber, props.pageSize, pagination]);

  return { loading, error, data, total, pagination, setPagination, reloadList: load };
}
